import { useEffect, useState } from 'react';
import { getRfiSummary } from 'api/kyc';
import RfiSummary from 'modules/kyc/components/RfiSummary';

function KycRfi() {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState({});

  useEffect(() => {
    const fetchRfiSummary = async () => {
      setIsLoading(true);
      try {
        const response = await getRfiSummary();

        setSummaryData(response?.data?.data || {});
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRfiSummary();
  }, []);

  return <RfiSummary summaryData={summaryData} isLoading={isLoading} error={error} />;
}

export default KycRfi;
